import { AxiosError, AxiosResponse } from 'axios';
import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { UseFormProps, SubmitHandler } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { cloneDeep } from 'lodash';

import { AdminPage } from '@/componentsAdmin/Layout/Page';
import { Column } from '@/components/common/Page';
import HeaderTitle from '@/components/common/Title/HeaderTitle';
import BaseButton from '@/components/common/Button/BaseButton';
import { NotificationMatchbou } from '@/components/common/Notification/Matchbou';
import { FormContainer } from '@/components/common/Form/Container';
import { ResumeFormSectionAddress } from '@/components/Resume/Form/SectionAddress';
// import { ResumeFormSectionCareer } from '@/components/Resume/Form/SectionCareer';
import {
  ResumeFormSectionEducationsAdmin,
  TFormValues,
} from '@/components/Resume/Form/SectionEducationsAdmin';
import { ResumeFormSectionFamily } from '@/components/Resume/Form/SectionFamily';
import { ResumeFormSectionHopeJob } from '@/components/Resume/Form/SectionHopeJob';
import { ResumeFormSectionInterestThings } from '@/components/Resume/Form/SectionInterestThings';
import { ResumeFormSectionLastUpdate } from '@/components/Resume/Form/SectionLastUpdate';
import { ResumeFormSectionProfile } from '@/components/Resume/Form/SectionProfile';
// import { ResumeFormSectionQualification } from '@/components/Resume/Form/SectionQualification';
import { ResumeFormSectionStatement } from '@/components/Resume/Form/SectionStatement';
import { setUploadedImage } from '@/redux/index';
import { toggleLoading, notificationError, notificationSuccess } from '@/reduxAdmin/modules/utils';
// import { usePageResumeFetch } from '@/hooks/usePageResume';
import { DataLayerContext } from '@/components/common/DataLayerProviderContainer';
import { MESSAGE } from '@/definitionAdmin/MESSAGE';
import { TPagesResumeFormValue } from '@/types/Pages/Resume';
import {
  ADMINApi,
  PortfolioApi,
  Resume,
  CareerSummaryModel,
  Qualification,
  QualificationQTypeEnum,
  ResponseError,
  FileResponse,
  EducationData,
  EducationPatchRequest,
  UserInfo,
} from '@/utils/api-client/api';
import { formatDate } from '@/utils/utils';

// Section用の型指定 共有なので読み込み側で指定してimportさせてる
export type TSectionProps = {
  id?: string;
  fetchData?: Resume | undefined;
};

const beforeUnloadHandler = (event: any) => {
  event.returnValue = MESSAGE.before_unload;
};

/**
 * 入力代行 履歴書 編集 /admin/transcription/C11111111/resume/edit
 * UI PC https://docs.google.com/presentation/d/1occFnVVBCMIQ0ftZiWFYGkVwEUKYgetIdp7-sE_pUKA/edit#slide=id.g2e6c4f0dd20_2_259
 */
export const AdminPagesResumeEdit = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { push } = useContext(DataLayerContext);
  // const getResumeData = usePageResumeFetch('admin_input_agency');
  const history = useHistory();
  const [resumeData, setResumeData] = useState<Resume | undefined>();
  const [iconSrc, setIconSrc] = useState<any | undefined>(
    resumeData?.user?.user_info?.photo?.f_url
  );
  const [iconState, setIconState] = useState<'stay' | 'change' | 'delete'>('stay');
  const [newEducation, setNewEducation] = useState<TFormValues | undefined>();
  const [updateEducations, setUpdateEducations] = useState<Array<number>>([]);
  const [delteEducations, setDelteEducations] = useState<{ e_id: string; index: number }[]>([]);
  const [updatedKey, setUpdatedKey] = useState<string[]>([]);
  const [targetUser, setTargetUser] = useState<UserInfo | null>(null);
  const [notification, setNotification] = useState<boolean>(true);
  const resumeKey = {
    user: [
      'name',
      'furigana',
      'gender',
      'birth',
      'postal_code',
      'address2',
      'address1',
      'email',
      'tel',
    ],
    careers: ['careers'],
    qualifications: ['qualifications'],
    resume: [
      'statement',
      'interest_things',
      'hope_job',
      'dependent_family',
      'partner',
      'duty_of_support',
    ],
  };
  const params = useParams<{ matchbox_id: string }>();
  const matchboxId = useMemo(() => params.matchbox_id, [params]);

  const setBeforeUnload = (flag: boolean) => {
    if (flag) {
      window.addEventListener('beforeunload', beforeUnloadHandler);
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    }
  };

  const checkInputAgencyStatus = async () => {
    if (!matchboxId) return;
    const res = await new ADMINApi().getAdminInputAgency(matchboxId);
    if (res.data && res.data.status !== 1) {
      history.push(`/admin/users/${matchboxId}`);
    }
  };

  useEffect(() => {
    if (!matchboxId) return;
    checkInputAgencyStatus();
    (async () => {
      const userResponse: AxiosResponse = await new ADMINApi().getAdminUserId(matchboxId);
      if (userResponse.data) {
        setTargetUser(userResponse.data.user_info);
      }
    })();
  }, [params]);

  useEffect(() => {
    (async () => {
      if (!targetUser?.user_id) return;
      const response = await new ADMINApi().getAdminInputAgencyResume(targetUser?.user_id);
      if (response) {
        const { result, ...resumeData } = response.data;
        setResumeData(resumeData);
      }
    })();
  }, [targetUser]);

  useEffect(() => {
    if (resumeData?.user?.user_info?.photo) setIconSrc(resumeData?.user?.user_info?.photo.f_url);
  }, [resumeData]);

  const birth = resumeData
    ? new Date(
        `${resumeData.user?.user_info?.birth_year}/${resumeData.user?.user_info?.birth_month}/${resumeData.user?.user_info?.birth_day}`
      )
    : new Date();

  const careers: CareerSummaryModel[] = [];
  if (resumeData?.careers) {
    Array.from(resumeData.careers.values()).forEach((career) => {
      const careersData: CareerSummaryModel = {
        c_id: '',
        c_company_name: '',
        c_join_date: '',
        c_leave_date: '',
        c_visible: true,
      };
      careersData.c_id = career.c_id;
      careersData.c_company_name = career.c_company_name;
      careersData.c_join_date = career.c_join_date;
      careersData.c_leave_date =
        career.c_leave_date && career.c_leave_flag ? career.c_leave_date : '現在';
      careersData.c_visible = career.c_visible;

      careers.push(careersData);
    });
  }

  const qualifications: Qualification[] = [];
  if (resumeData?.qualifications) {
    Array.from(resumeData.qualifications.values()).forEach((qualification) => {
      const qualificationsData: Qualification = {
        q_id: '',
        q_type: QualificationQTypeEnum.Text,
        q_title: '',
        q_date: '',
        q_score: '',
        q_visible: true,
      };
      qualificationsData.q_id = qualification.q_id;
      qualificationsData.q_type = qualification.q_type;
      qualificationsData.q_title = qualification.q_title;
      qualificationsData.q_date = qualification.q_date;
      qualificationsData.q_score = qualification.q_score;
      qualificationsData.q_visible = qualification.q_visible;

      qualifications.push(qualificationsData);
    });
  }

  const useFormProps: UseFormProps = {
    mode: 'onBlur',
    defaultValues: {
      name: resumeData ? resumeData.user?.user_info?.name : '',
      furigana: resumeData ? resumeData.user?.user_info?.furigana : '',
      gender: resumeData ? resumeData.user?.user_info?.gender?.toString() : '',
      birth: formatDate(birth, 'YYYY年MM月DD日'),
      tel: resumeData ? resumeData.user?.user_info?.tel : '',
      postal_code: resumeData ? resumeData.user?.user_info?.postal_code : '',
      email: resumeData ? resumeData.user?.user_info?.email : '',
      address1: resumeData ? resumeData.user?.user_info?.address1 : '',
      address2: resumeData ? resumeData.user?.user_info?.address2 : '',
      careers: careers,
      qualifications: qualifications,
      statement: resumeData ? resumeData.resume?.statement : '',
      interest_things: resumeData ? resumeData.resume?.interest_things : '',
      hope_job: resumeData ? resumeData.resume?.hope_job : '',
      dependent_family: resumeData ? resumeData.resume?.dependent_family : '',
      partner: resumeData ? resumeData.resume?.partner?.toString() : '',
      duty_of_support: resumeData ? resumeData.resume?.duty_of_support?.toString() : '',
      yyyy:
        resumeData && resumeData.user?.last_update_portfolio
          ? formatDate(new Date(resumeData.user?.last_update_portfolio), 'YYYY')
          : formatDate(new Date(), 'YYYY'),
      mm:
        resumeData && resumeData.user?.last_update_portfolio
          ? formatDate(new Date(resumeData.user?.last_update_portfolio), 'MM')
          : formatDate(new Date(), 'MM'),
      dd:
        resumeData && resumeData.user?.last_update_portfolio
          ? formatDate(new Date(resumeData.user?.last_update_portfolio), 'DD')
          : formatDate(new Date(), 'DD'),
    },
  };

  const onSubmit: SubmitHandler<TPagesResumeFormValue> = async (formData, e) => {
    const data: any = {
      user: { user_info: {} },
      careers: [],
      qualifications: [],
      resume: {},
      educations: [],
    };
    dispatch(toggleLoading(true));
    try {
      // 更新があったkeyのみを変換して利用する
      Object.keys(formData).forEach(function (key) {
        if (!updatedKey.includes(key)) return;

        if (resumeKey.user.includes(key)) {
          data.user.user_info[key] = formData[key] !== '' ? formData[key] : null;
        } else if (resumeKey.careers.includes(key)) {
          data.careers = formData[key];
        } else if (resumeKey.qualifications.includes(key)) {
          data.qualifications = formData[key];
        } else if (resumeKey.resume.includes(key)) {
          if (formData[key] === 'true') {
            formData[key] = true;
          } else if (formData[key] === 'false') {
            formData[key] = false;
          }
          data.resume[key] = formData[key];
        }
      });

      // 学歴
      if (newEducation) {
        data.educations = await educationUpdate(newEducation, 'advance');
      }

      // 証明写真
      if (iconState === 'change' && iconSrc && targetUser?.user_id) {
        const result = await new ADMINApi().postAdminUserIdFiles(targetUser?.user_id, iconSrc);
        push({
          event: 'fileUpload',
          actionType: 'file_upload',
          actionName: '画像',
        });
        const fileData: FileResponse = result.data;
        data.user.user_info.photo = {
          f_id: fileData.f_id,
        };
      } else if (iconState === 'delete') {
        data.user.user_info.photo = {};
      }

      if (targetUser?.user_id) {
        // 履歴書
        const res = await new ADMINApi().patchAdminInputAgencyResume(
          targetUser?.user_id,
          data as Resume
        );

        // 証明写真削除
        if (iconState !== 'stay' && resumeData?.user?.user_info?.photo?.f_id) {
          await new ADMINApi().deleteAdminUserIdFiles(
            targetUser?.user_id,
            resumeData?.user?.user_info?.photo.f_id
          );
          dispatch(setUploadedImage(null));
        }

        const { result, ...resume } = res.data;
        setResumeData(resume);
        setIconState('stay');
        setUpdatedKey([]);
        setUpdateEducations([]);
        setDelteEducations([]);
        setNewEducation(undefined);
        setBeforeUnload(false);
        dispatch(notificationSuccess(MESSAGE.saving_completed));
        // 確認ボタンの場合はプレビューに進む
        const event = e as React.BaseSyntheticEvent<Record<string, unknown>, any, any> | undefined;
        const button = event?.nativeEvent?.submitter as HTMLButtonElement;
        if (button.textContent === '反映を確認する') {
          history.push(`/admin/transcription/${matchboxId}`);
        }
      }
    } catch (e) {
      // ロールバック処理
      if (newEducation && resumeData?.educations) {
        await educationUpdate(
          { educations: Array.from(resumeData?.educations) } as TFormValues,
          'revert'
        );
      }
      if (data.user.user_info.photo && data.user.user_info.photo.f_id) {
        await new PortfolioApi().deleteFiles(data.user.user_info.photo.f_id);
      }
      if (targetUser?.user_id) {
        await new ADMINApi().patchAdminInputAgencyResume(targetUser?.user_id, resumeData);
      }

      const error = e as AxiosError<ResponseError>;
      if (error.response) dispatch(notificationError(error.response.data.error_message));
    } finally {
      dispatch(toggleLoading(false));
    }
  };

  const educationUpdate = async (
    data: TFormValues,
    state: 'advance' | 'revert'
  ): Promise<EducationData[]> => {
    const postEducations: (EducationPatchRequest & { index: number })[] = [];
    const patchEducations: EducationPatchRequest[] = [];
    const delEducations: { e_id: string; index: number }[] =
      state === 'advance' ? delteEducations : [];
    const newEducations: EducationData[] = cloneDeep(data.educations);

    data.educations.forEach((value, index) => {
      const data: EducationPatchRequest = {
        e_id: value.e_id,
        e_school_name: value.e_school_name,
        e_graduate_date: value.e_graduate_date_yyyy + '-' + value.e_graduate_date_mm,
      };
      if (!value.e_graduate_date_yyyy && !value.e_graduate_date_mm) data.e_graduate_date = null;
      if (!data.e_id) postEducations.push({ ...data, index: index });
      if (state === 'advance' && updateEducations.includes(Number(data.e_id))) {
        patchEducations.push(data);
      } else if (state === 'revert') {
        const revertValue = value as EducationData;
        data.e_graduate_date = revertValue.e_graduate_date;
        patchEducations.push(data);
      }
    });

    if (targetUser?.user_id) {
      if (state === 'revert') {
        // 既に登録された学歴を取得する
        new ADMINApi().getAdminInputAgencyResume(targetUser?.user_id).then((res) => {
          const response = res.data;
          if (response.educations) {
            Array.from(response.educations).forEach((reRducation, index) => {
              if (
                data.educations.filter((education) => education.e_id === reRducation.e_id)
                  .length === 0
              ) {
                delEducations.push({ e_id: reRducation.e_id, index: index });
              }
            });
          }
        });
      }
      // 登録処理
      if (postEducations.length !== 0) {
        for (let i = 0; i < postEducations.length; i++) {
          const { index, ...postEducation } = postEducations[i];
          const res = await new ADMINApi().postAdminInputAgencyResumeUserIdEducations(
            targetUser?.user_id,
            postEducation
          );
          const educations = res.data.educations;
          newEducations[index] = educations[educations.length - 1];
        }
      }
      // 更新処理
      if (patchEducations.length !== 0) {
        for (let i = 0; i < patchEducations.length; i++) {
          await new ADMINApi().patchAdminInputAgencyResumeUserIdEducations(
            targetUser?.user_id,
            patchEducations[i]
          );
        }
      }
      // 削除処理
      if (delEducations.length !== 0) {
        for (let i = 0; i < delEducations.length; i++) {
          await new ADMINApi().deleteAdminInputAgencyResumeUserIdEducations(
            delEducations[i].e_id,
            targetUser?.user_id
          );
        }
      }
    }

    return newEducations;
  };

  return (
    <AdminPage
      public_header
      header={
        <div className="sticky top-0 z-10">
          <HeaderTitle title={`${params.matchbox_id}｜入力代行【履歴書】`}>
            <div className="flex justify-end sm:-mr-16">
              <BaseButton
                theme="secondary"
                size="40"
                width="large"
                className="pr-10"
                form="pagesResumeEdit"
              >
                保存する
              </BaseButton>
              <BaseButton theme="primary" size="40" form="pagesResumeEdit" width="large">
                反映を確認する
              </BaseButton>
            </div>
          </HeaderTitle>
        </div>
      }
    >
      <>
        <div className="sticky top-60 z-10 mt-16">
          <NotificationMatchbou
            show={notification}
            showMatchbou={false}
            onClick={() => setNotification(false)}
          >
            職務経歴書に入力代行した内容はMATCHBOX登録企業にそのまま公開される可能性があるため、個人情報を入力しないようにしてください。
          </NotificationMatchbou>
        </div>
        <Column
          main={
            <div className="pt-48 pb-100 sm:pt-24 sm:mb-144 mt-16">
              <FormContainer
                useFormProps={useFormProps}
                onSubmit={onSubmit}
                fetchData={resumeData}
                id="pagesResumeEdit"
                setUpdatedKey={setUpdatedKey}
                setBeforeUnload={setBeforeUnload}
              >
                <div className="mbx-utils-stack-v--48">
                  <ResumeFormSectionProfile
                    id="Profile"
                    iconSrc={iconSrc}
                    setIconSrc={setIconSrc}
                    setIconState={setIconState}
                    agent={true}
                  />
                  <ResumeFormSectionAddress id="Address" agent={true} />
                  <ResumeFormSectionEducationsAdmin
                    id="Education"
                    fetchData={resumeData}
                    newEducation={newEducation}
                    setNewEducation={setNewEducation}
                    setUpdateEducations={setUpdateEducations}
                    setDelteEducations={setDelteEducations}
                    userId={targetUser?.user_id}
                  />
                  {/* <ResumeFormSectionCareer id="Career" />
                <ResumeFormSectionQualification id="Qualification" /> */}
                  <ResumeFormSectionStatement id="Statement" />
                  <ResumeFormSectionInterestThings id="InterestThings" />
                  <ResumeFormSectionHopeJob id="HopeJob" />
                  <ResumeFormSectionFamily id="Family" />
                  <ResumeFormSectionLastUpdate />
                </div>
              </FormContainer>
            </div>
          }
          menu={<></>}
        />
      </>
    </AdminPage>
  );
};
